module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_3016.1bbc027d.png";